export const FLOATING_PANE_CRYPTO_REWARDS_TYPE = 'cryptoRewards'

export const FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE = {
  type: FLOATING_PANE_CRYPTO_REWARDS_TYPE as typeof FLOATING_PANE_CRYPTO_REWARDS_TYPE,
}

export const FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE = 'cryptoRewardsBuyMode' as const

export const FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE = 'cryptoRewardsSellMode' as const

export const FLOATING_PANE_AUTO_INVESTMENTS_MODE = 'cryptoRewardsAutoInvestmentsMode' as const

export const FLOATING_PANE_ORDER_DETAILS_MODE = 'cryptoRewardsPaneOrderDetailsMode' as const

